import { getSearchConfig } from "@/components/dynamic-form/helper/getSearchConfig";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { SearchBarType } from "@/components/dynamic-form/constants";
import dayjs from "project-config/utils/dayjs";
import { getToday, ONE_WEEK } from "@/utils/date-formatter/getToday";
import { useMemo } from "react";
import { useUserPackNode } from "./useUserPackNode";

export function useSearchConfig() {
  const now = getToday();
  const weekAgo = new Date(now.getTime() - ONE_WEEK);
  const { data: userPackNode } = useUserPackNode();

  const machineOptions = useMemo(
    () =>
      userPackNode?.packName.map((item) => ({
        label: item,
        value: item,
      })),
    [userPackNode]
  );

  const userOptions = useMemo(
    () =>
      userPackNode?.userName.map((item) => ({
        label: item,
        value: item,
      })),
    [userPackNode]
  );

  const searchConfig = getSearchConfig(() => {
    const t = getTranslateNsT("consumption");
    const centerT = getTranslateNsT("center");
    return [
      {
        type: SearchBarType.DatePicker,
        field: "time",
        label: t("consumption_time_selector"),
        limitMonthNum: 3,
        isTrendsChangeDate: true,
        props: {
          allowClear: false,
          defaultValue: [dayjs(weekAgo), dayjs(now)],
        },
      },
      {
        type: SearchBarType.Select,
        label: centerT("user_operate_record_machine"),
        field: "packName",
        props: {
          allowClear: true,
          options: machineOptions,
          placeholder: t("consume_pick_platform_all"),
        },
      },
      {
        type: SearchBarType.Select,
        label: t("user_operate_record_user_name_alias"),
        field: "userName",
        props: {
          allowClear: true,
          options: userOptions,
          placeholder: t("consume_pick_platform_all"),
        },
      },
    ];
  });
  return { searchConfig, machineOptions };
}
